// POOCOO Lite - Entry Point

import "./styles/site.scss";
import { init } from "./scripts/site";

document.addEventListener("DOMContentLoaded", init);
